//selects first item on the navbar as fallback default
const getFirstMenuHomePath = (menuItems) => {
  const firstId = menuItems?.[0]?.id;
  if (firstId === undefined || firstId === null) return null;
  return `/dashboard/home/${firstId}/all`;
};

export { getFirstMenuHomePath };
